import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// French translations (FR, BE, LU, CH)
import frCommon from './locales/fr/common.json';
import frNavigation from './locales/fr/navigation.json';
import frArticles from './locales/fr/articles.json';
import frPricing from './locales/fr/pricing.json';
import frSubscription from './locales/fr/subscription.json';
import frDocumentation from './locales/fr/documentation.json';
import frProfile from './locales/fr/profile.json';
import frAuth from './locales/fr/auth.json';
import frDashboardUser from './locales/fr/dashboardUser.json';
import frSupport from './locales/fr/support.json';
import frHome from './locales/fr/home.json';
import frAffiliate from './locales/fr/affiliate.json';
import frSeo from './locales/fr/seo.json';
import frStatistics from './locales/fr/statistics.json';
import frBilling from './locales/fr/billing.json';
import frTags from './locales/fr/tags.json';
import frMasks from './locales/fr/masks.json';
import frSalesDashboard from './locales/fr/salesDashboard.json';
import frEmailPreferences from './locales/fr/emailPreferences.json';
import frOrders from './locales/fr/orders.json';
import frPaidOptions from './locales/fr/paidOptions.json';
import frScheduling from './locales/fr/scheduling.json';
import frActionHistory from './locales/fr/actionHistory.json';
import frDocAutomation from './locales/fr/docAutomation.json';
import frDocWoocommerce from './locales/fr/docWoocommerce.json';
import frDocShopify from './locales/fr/docShopify.json';
import frCgu from './locales/fr/cgu.json';
import frPrivacy from './locales/fr/privacy.json';
import frFaq from './locales/fr/faq.json';

// English translations (EN - GB, US, IE)
import enCommon from './locales/en/common.json';
import enNavigation from './locales/en/navigation.json';
import enArticles from './locales/en/articles.json';
import enPricing from './locales/en/pricing.json';
import enSubscription from './locales/en/subscription.json';
import enDocumentation from './locales/en/documentation.json';
import enProfile from './locales/en/profile.json';
import enAuth from './locales/en/auth.json';
import enDashboardUser from './locales/en/dashboardUser.json';
import enSupport from './locales/en/support.json';
import enHome from './locales/en/home.json';
import enAffiliate from './locales/en/affiliate.json';
import enSeo from './locales/en/seo.json';
import enStatistics from './locales/en/statistics.json';
import enBilling from './locales/en/billing.json';
import enTags from './locales/en/tags.json';
import enMasks from './locales/en/masks.json';
import enSalesDashboard from './locales/en/salesDashboard.json';
import enEmailPreferences from './locales/en/emailPreferences.json';
import enOrders from './locales/en/orders.json';
import enPaidOptions from './locales/en/paidOptions.json';
import enScheduling from './locales/en/scheduling.json';
import enActionHistory from './locales/en/actionHistory.json';
import enDocAutomation from './locales/en/docAutomation.json';
import enDocWoocommerce from './locales/en/docWoocommerce.json';
import enDocShopify from './locales/en/docShopify.json';
import enCgu from './locales/en/cgu.json';
import enPrivacy from './locales/en/privacy.json';
import enFaq from './locales/en/faq.json';

// Czech translations (CS - CZ)
import csCommon from './locales/cs/common.json';
import csNavigation from './locales/cs/navigation.json';
import csArticles from './locales/cs/articles.json';
import csPricing from './locales/cs/pricing.json';
import csSubscription from './locales/cs/subscription.json';
import csDocumentation from './locales/cs/documentation.json';
import csProfile from './locales/cs/profile.json';
import csAuth from './locales/cs/auth.json';
import csDashboardUser from './locales/cs/dashboardUser.json';
import csSupport from './locales/cs/support.json';
import csHome from './locales/cs/home.json';
import csAffiliate from './locales/cs/affiliate.json';
import csSeo from './locales/cs/seo.json';
import csStatistics from './locales/cs/statistics.json';
import csBilling from './locales/cs/billing.json';
import csTags from './locales/cs/tags.json';
import csMasks from './locales/cs/masks.json';
import csSalesDashboard from './locales/cs/salesDashboard.json';
import csOrders from './locales/cs/orders.json';
import csScheduling from './locales/cs/scheduling.json';
import csActionHistory from './locales/cs/actionHistory.json';
import csDocAutomation from './locales/cs/docAutomation.json';
import csDocWoocommerce from './locales/cs/docWoocommerce.json';
import csDocShopify from './locales/cs/docShopify.json';
import csCgu from './locales/cs/cgu.json';
import csPrivacy from './locales/cs/privacy.json';
import csFaq from './locales/cs/faq.json';

// German translations (DE - DE, AT)
import deCommon from './locales/de/common.json';
import deNavigation from './locales/de/navigation.json';
import deArticles from './locales/de/articles.json';
import dePricing from './locales/de/pricing.json';
import deSubscription from './locales/de/subscription.json';
import deDocumentation from './locales/de/documentation.json';
import deProfile from './locales/de/profile.json';
import deAuth from './locales/de/auth.json';
import deDashboardUser from './locales/de/dashboardUser.json';
import deSupport from './locales/de/support.json';
import deHome from './locales/de/home.json';
import deAffiliate from './locales/de/affiliate.json';
import deSeo from './locales/de/seo.json';
import deStatistics from './locales/de/statistics.json';
import deBilling from './locales/de/billing.json';
import deTags from './locales/de/tags.json';
import deMasks from './locales/de/masks.json';
import deSalesDashboard from './locales/de/salesDashboard.json';
import deOrders from './locales/de/orders.json';
import deScheduling from './locales/de/scheduling.json';
import deActionHistory from './locales/de/actionHistory.json';
import deDocAutomation from './locales/de/docAutomation.json';
import deDocWoocommerce from './locales/de/docWoocommerce.json';
import deDocShopify from './locales/de/docShopify.json';
import deCgu from './locales/de/cgu.json';
import dePrivacy from './locales/de/privacy.json';
import deFaq from './locales/de/faq.json';

// Danish translations (DA - DK)
import daCommon from './locales/da/common.json';
import daNavigation from './locales/da/navigation.json';
import daArticles from './locales/da/articles.json';
import daPricing from './locales/da/pricing.json';
import daSubscription from './locales/da/subscription.json';
import daDocumentation from './locales/da/documentation.json';
import daProfile from './locales/da/profile.json';
import daAuth from './locales/da/auth.json';
import daDashboardUser from './locales/da/dashboardUser.json';
import daSupport from './locales/da/support.json';
import daHome from './locales/da/home.json';
import daAffiliate from './locales/da/affiliate.json';
import daSeo from './locales/da/seo.json';
import daStatistics from './locales/da/statistics.json';
import daBilling from './locales/da/billing.json';
import daTags from './locales/da/tags.json';
import daMasks from './locales/da/masks.json';
import daSalesDashboard from './locales/da/salesDashboard.json';
import daOrders from './locales/da/orders.json';
import daScheduling from './locales/da/scheduling.json';
import daActionHistory from './locales/da/actionHistory.json';
import daDocAutomation from './locales/da/docAutomation.json';
import daDocWoocommerce from './locales/da/docWoocommerce.json';
import daDocShopify from './locales/da/docShopify.json';
import daCgu from './locales/da/cgu.json';
import daPrivacy from './locales/da/privacy.json';
import daFaq from './locales/da/faq.json';

// Spanish translations (ES - ES)
import esCommon from './locales/es/common.json';
import esNavigation from './locales/es/navigation.json';
import esArticles from './locales/es/articles.json';
import esPricing from './locales/es/pricing.json';
import esSubscription from './locales/es/subscription.json';
import esDocumentation from './locales/es/documentation.json';
import esProfile from './locales/es/profile.json';
import esAuth from './locales/es/auth.json';
import esDashboardUser from './locales/es/dashboardUser.json';
import esSupport from './locales/es/support.json';
import esHome from './locales/es/home.json';
import esAffiliate from './locales/es/affiliate.json';
import esSeo from './locales/es/seo.json';
import esStatistics from './locales/es/statistics.json';
import esBilling from './locales/es/billing.json';
import esTags from './locales/es/tags.json';
import esMasks from './locales/es/masks.json';
import esSalesDashboard from './locales/es/salesDashboard.json';
import esOrders from './locales/es/orders.json';
import esScheduling from './locales/es/scheduling.json';
import esActionHistory from './locales/es/actionHistory.json';
import esDocAutomation from './locales/es/docAutomation.json';
import esDocWoocommerce from './locales/es/docWoocommerce.json';
import esDocShopify from './locales/es/docShopify.json';
import esCgu from './locales/es/cgu.json';
import esPrivacy from './locales/es/privacy.json';
import esFaq from './locales/es/faq.json';

// Finnish translations (FI - FI)
import fiCommon from './locales/fi/common.json';
import fiNavigation from './locales/fi/navigation.json';
import fiArticles from './locales/fi/articles.json';
import fiPricing from './locales/fi/pricing.json';
import fiSubscription from './locales/fi/subscription.json';
import fiDocumentation from './locales/fi/documentation.json';
import fiProfile from './locales/fi/profile.json';
import fiAuth from './locales/fi/auth.json';
import fiDashboardUser from './locales/fi/dashboardUser.json';
import fiSupport from './locales/fi/support.json';
import fiHome from './locales/fi/home.json';
import fiAffiliate from './locales/fi/affiliate.json';
import fiSeo from './locales/fi/seo.json';
import fiStatistics from './locales/fi/statistics.json';
import fiBilling from './locales/fi/billing.json';
import fiTags from './locales/fi/tags.json';
import fiMasks from './locales/fi/masks.json';
import fiSalesDashboard from './locales/fi/salesDashboard.json';
import fiOrders from './locales/fi/orders.json';
import fiScheduling from './locales/fi/scheduling.json';
import fiActionHistory from './locales/fi/actionHistory.json';
import fiDocAutomation from './locales/fi/docAutomation.json';
import fiDocWoocommerce from './locales/fi/docWoocommerce.json';
import fiDocShopify from './locales/fi/docShopify.json';
import fiCgu from './locales/fi/cgu.json';
import fiPrivacy from './locales/fi/privacy.json';
import fiFaq from './locales/fi/faq.json';

// Greek translations (EL - GR)
import elCommon from './locales/el/common.json';
import elNavigation from './locales/el/navigation.json';
import elArticles from './locales/el/articles.json';
import elPricing from './locales/el/pricing.json';
import elSubscription from './locales/el/subscription.json';
import elDocumentation from './locales/el/documentation.json';
import elProfile from './locales/el/profile.json';
import elAuth from './locales/el/auth.json';
import elDashboardUser from './locales/el/dashboardUser.json';
import elSupport from './locales/el/support.json';
import elHome from './locales/el/home.json';
import elAffiliate from './locales/el/affiliate.json';
import elSeo from './locales/el/seo.json';
import elStatistics from './locales/el/statistics.json';
import elBilling from './locales/el/billing.json';
import elTags from './locales/el/tags.json';
import elMasks from './locales/el/masks.json';
import elSalesDashboard from './locales/el/salesDashboard.json';
import elOrders from './locales/el/orders.json';
import elScheduling from './locales/el/scheduling.json';
import elActionHistory from './locales/el/actionHistory.json';
import elDocAutomation from './locales/el/docAutomation.json';
import elDocWoocommerce from './locales/el/docWoocommerce.json';
import elDocShopify from './locales/el/docShopify.json';
import elCgu from './locales/el/cgu.json';
import elPrivacy from './locales/el/privacy.json';
import elFaq from './locales/el/faq.json';

// Croatian translations (HR - HR)
import hrCommon from './locales/hr/common.json';
import hrNavigation from './locales/hr/navigation.json';
import hrArticles from './locales/hr/articles.json';
import hrPricing from './locales/hr/pricing.json';
import hrSubscription from './locales/hr/subscription.json';
import hrDocumentation from './locales/hr/documentation.json';
import hrProfile from './locales/hr/profile.json';
import hrAuth from './locales/hr/auth.json';
import hrDashboardUser from './locales/hr/dashboardUser.json';
import hrSupport from './locales/hr/support.json';
import hrHome from './locales/hr/home.json';
import hrAffiliate from './locales/hr/affiliate.json';
import hrSeo from './locales/hr/seo.json';
import hrStatistics from './locales/hr/statistics.json';
import hrBilling from './locales/hr/billing.json';
import hrTags from './locales/hr/tags.json';
import hrMasks from './locales/hr/masks.json';
import hrSalesDashboard from './locales/hr/salesDashboard.json';
import hrOrders from './locales/hr/orders.json';
import hrScheduling from './locales/hr/scheduling.json';
import hrActionHistory from './locales/hr/actionHistory.json';
import hrDocAutomation from './locales/hr/docAutomation.json';
import hrDocWoocommerce from './locales/hr/docWoocommerce.json';
import hrDocShopify from './locales/hr/docShopify.json';
import hrCgu from './locales/hr/cgu.json';
import hrPrivacy from './locales/hr/privacy.json';
import hrFaq from './locales/hr/faq.json';

// Hungarian translations (HU - HU)
import huCommon from './locales/hu/common.json';
import huNavigation from './locales/hu/navigation.json';
import huArticles from './locales/hu/articles.json';
import huPricing from './locales/hu/pricing.json';
import huSubscription from './locales/hu/subscription.json';
import huDocumentation from './locales/hu/documentation.json';
import huProfile from './locales/hu/profile.json';
import huAuth from './locales/hu/auth.json';
import huDashboardUser from './locales/hu/dashboardUser.json';
import huSupport from './locales/hu/support.json';
import huHome from './locales/hu/home.json';
import huAffiliate from './locales/hu/affiliate.json';
import huSeo from './locales/hu/seo.json';
import huStatistics from './locales/hu/statistics.json';
import huBilling from './locales/hu/billing.json';
import huTags from './locales/hu/tags.json';
import huMasks from './locales/hu/masks.json';
import huSalesDashboard from './locales/hu/salesDashboard.json';
import huOrders from './locales/hu/orders.json';
import huScheduling from './locales/hu/scheduling.json';
import huActionHistory from './locales/hu/actionHistory.json';
import huDocAutomation from './locales/hu/docAutomation.json';
import huDocWoocommerce from './locales/hu/docWoocommerce.json';
import huDocShopify from './locales/hu/docShopify.json';
import huCgu from './locales/hu/cgu.json';
import huPrivacy from './locales/hu/privacy.json';
import huFaq from './locales/hu/faq.json';

// Italian translations (IT - IT)
import itCommon from './locales/it/common.json';
import itNavigation from './locales/it/navigation.json';
import itArticles from './locales/it/articles.json';
import itPricing from './locales/it/pricing.json';
import itSubscription from './locales/it/subscription.json';
import itDocumentation from './locales/it/documentation.json';
import itProfile from './locales/it/profile.json';
import itAuth from './locales/it/auth.json';
import itDashboardUser from './locales/it/dashboardUser.json';
import itSupport from './locales/it/support.json';
import itHome from './locales/it/home.json';
import itAffiliate from './locales/it/affiliate.json';
import itSeo from './locales/it/seo.json';
import itStatistics from './locales/it/statistics.json';
import itBilling from './locales/it/billing.json';
import itTags from './locales/it/tags.json';
import itMasks from './locales/it/masks.json';
import itSalesDashboard from './locales/it/salesDashboard.json';
import itOrders from './locales/it/orders.json';
import itScheduling from './locales/it/scheduling.json';
import itActionHistory from './locales/it/actionHistory.json';
import itDocAutomation from './locales/it/docAutomation.json';
import itDocWoocommerce from './locales/it/docWoocommerce.json';
import itDocShopify from './locales/it/docShopify.json';
import itCgu from './locales/it/cgu.json';
import itPrivacy from './locales/it/privacy.json';
import itFaq from './locales/it/faq.json';

// Lithuanian translations (LT - LT)
import ltCommon from './locales/lt/common.json';
import ltNavigation from './locales/lt/navigation.json';
import ltArticles from './locales/lt/articles.json';
import ltPricing from './locales/lt/pricing.json';
import ltSubscription from './locales/lt/subscription.json';
import ltDocumentation from './locales/lt/documentation.json';
import ltProfile from './locales/lt/profile.json';
import ltAuth from './locales/lt/auth.json';
import ltDashboardUser from './locales/lt/dashboardUser.json';
import ltSupport from './locales/lt/support.json';
import ltHome from './locales/lt/home.json';
import ltAffiliate from './locales/lt/affiliate.json';
import ltSeo from './locales/lt/seo.json';
import ltStatistics from './locales/lt/statistics.json';
import ltBilling from './locales/lt/billing.json';
import ltTags from './locales/lt/tags.json';
import ltMasks from './locales/lt/masks.json';
import ltSalesDashboard from './locales/lt/salesDashboard.json';
import ltOrders from './locales/lt/orders.json';
import ltScheduling from './locales/lt/scheduling.json';
import ltActionHistory from './locales/lt/actionHistory.json';
import ltDocAutomation from './locales/lt/docAutomation.json';
import ltDocWoocommerce from './locales/lt/docWoocommerce.json';
import ltDocShopify from './locales/lt/docShopify.json';
import ltCgu from './locales/lt/cgu.json';
import ltPrivacy from './locales/lt/privacy.json';
import ltFaq from './locales/lt/faq.json';

// Dutch translations (NL - NL)
import nlCommon from './locales/nl/common.json';
import nlNavigation from './locales/nl/navigation.json';
import nlArticles from './locales/nl/articles.json';
import nlPricing from './locales/nl/pricing.json';
import nlSubscription from './locales/nl/subscription.json';
import nlDocumentation from './locales/nl/documentation.json';
import nlProfile from './locales/nl/profile.json';
import nlAuth from './locales/nl/auth.json';
import nlDashboardUser from './locales/nl/dashboardUser.json';
import nlSupport from './locales/nl/support.json';
import nlHome from './locales/nl/home.json';
import nlAffiliate from './locales/nl/affiliate.json';
import nlSeo from './locales/nl/seo.json';
import nlStatistics from './locales/nl/statistics.json';
import nlBilling from './locales/nl/billing.json';
import nlTags from './locales/nl/tags.json';
import nlMasks from './locales/nl/masks.json';
import nlSalesDashboard from './locales/nl/salesDashboard.json';
import nlOrders from './locales/nl/orders.json';
import nlScheduling from './locales/nl/scheduling.json';
import nlActionHistory from './locales/nl/actionHistory.json';
import nlDocAutomation from './locales/nl/docAutomation.json';
import nlDocWoocommerce from './locales/nl/docWoocommerce.json';
import nlDocShopify from './locales/nl/docShopify.json';
import nlCgu from './locales/nl/cgu.json';
import nlPrivacy from './locales/nl/privacy.json';
import nlFaq from './locales/nl/faq.json';

// Polish translations (PL - PL)
import plCommon from './locales/pl/common.json';
import plNavigation from './locales/pl/navigation.json';
import plArticles from './locales/pl/articles.json';
import plPricing from './locales/pl/pricing.json';
import plSubscription from './locales/pl/subscription.json';
import plDocumentation from './locales/pl/documentation.json';
import plProfile from './locales/pl/profile.json';
import plAuth from './locales/pl/auth.json';
import plDashboardUser from './locales/pl/dashboardUser.json';
import plSupport from './locales/pl/support.json';
import plHome from './locales/pl/home.json';
import plAffiliate from './locales/pl/affiliate.json';
import plSeo from './locales/pl/seo.json';
import plStatistics from './locales/pl/statistics.json';
import plBilling from './locales/pl/billing.json';
import plTags from './locales/pl/tags.json';
import plMasks from './locales/pl/masks.json';
import plSalesDashboard from './locales/pl/salesDashboard.json';
import plOrders from './locales/pl/orders.json';
import plScheduling from './locales/pl/scheduling.json';
import plActionHistory from './locales/pl/actionHistory.json';
import plDocAutomation from './locales/pl/docAutomation.json';
import plDocWoocommerce from './locales/pl/docWoocommerce.json';
import plDocShopify from './locales/pl/docShopify.json';
import plCgu from './locales/pl/cgu.json';
import plPrivacy from './locales/pl/privacy.json';
import plFaq from './locales/pl/faq.json';

// Portuguese translations (PT - PT)
import ptCommon from './locales/pt/common.json';
import ptNavigation from './locales/pt/navigation.json';
import ptArticles from './locales/pt/articles.json';
import ptPricing from './locales/pt/pricing.json';
import ptSubscription from './locales/pt/subscription.json';
import ptDocumentation from './locales/pt/documentation.json';
import ptProfile from './locales/pt/profile.json';
import ptAuth from './locales/pt/auth.json';
import ptDashboardUser from './locales/pt/dashboardUser.json';
import ptSupport from './locales/pt/support.json';
import ptHome from './locales/pt/home.json';
import ptAffiliate from './locales/pt/affiliate.json';
import ptSeo from './locales/pt/seo.json';
import ptStatistics from './locales/pt/statistics.json';
import ptBilling from './locales/pt/billing.json';
import ptTags from './locales/pt/tags.json';
import ptMasks from './locales/pt/masks.json';
import ptSalesDashboard from './locales/pt/salesDashboard.json';
import ptOrders from './locales/pt/orders.json';
import ptScheduling from './locales/pt/scheduling.json';
import ptActionHistory from './locales/pt/actionHistory.json';
import ptDocAutomation from './locales/pt/docAutomation.json';
import ptDocWoocommerce from './locales/pt/docWoocommerce.json';
import ptDocShopify from './locales/pt/docShopify.json';
import ptCgu from './locales/pt/cgu.json';
import ptPrivacy from './locales/pt/privacy.json';
import ptFaq from './locales/pt/faq.json';

// Romanian translations (RO - RO)
import roCommon from './locales/ro/common.json';
import roNavigation from './locales/ro/navigation.json';
import roArticles from './locales/ro/articles.json';
import roPricing from './locales/ro/pricing.json';
import roSubscription from './locales/ro/subscription.json';
import roDocumentation from './locales/ro/documentation.json';
import roProfile from './locales/ro/profile.json';
import roAuth from './locales/ro/auth.json';
import roDashboardUser from './locales/ro/dashboardUser.json';
import roSupport from './locales/ro/support.json';
import roHome from './locales/ro/home.json';
import roAffiliate from './locales/ro/affiliate.json';
import roSeo from './locales/ro/seo.json';
import roStatistics from './locales/ro/statistics.json';
import roBilling from './locales/ro/billing.json';
import roTags from './locales/ro/tags.json';
import roMasks from './locales/ro/masks.json';
import roSalesDashboard from './locales/ro/salesDashboard.json';
import roOrders from './locales/ro/orders.json';
import roScheduling from './locales/ro/scheduling.json';
import roActionHistory from './locales/ro/actionHistory.json';
import roDocAutomation from './locales/ro/docAutomation.json';
import roDocWoocommerce from './locales/ro/docWoocommerce.json';
import roDocShopify from './locales/ro/docShopify.json';
import roCgu from './locales/ro/cgu.json';
import roPrivacy from './locales/ro/privacy.json';
import roFaq from './locales/ro/faq.json';

// Swedish translations (SV - SE)
import svCommon from './locales/sv/common.json';
import svNavigation from './locales/sv/navigation.json';
import svArticles from './locales/sv/articles.json';
import svPricing from './locales/sv/pricing.json';
import svSubscription from './locales/sv/subscription.json';
import svDocumentation from './locales/sv/documentation.json';
import svProfile from './locales/sv/profile.json';
import svAuth from './locales/sv/auth.json';
import svDashboardUser from './locales/sv/dashboardUser.json';
import svSupport from './locales/sv/support.json';
import svHome from './locales/sv/home.json';
import svAffiliate from './locales/sv/affiliate.json';
import svSeo from './locales/sv/seo.json';
import svStatistics from './locales/sv/statistics.json';
import svBilling from './locales/sv/billing.json';
import svTags from './locales/sv/tags.json';
import svMasks from './locales/sv/masks.json';
import svSalesDashboard from './locales/sv/salesDashboard.json';
import svOrders from './locales/sv/orders.json';
import svScheduling from './locales/sv/scheduling.json';
import svActionHistory from './locales/sv/actionHistory.json';
import svDocAutomation from './locales/sv/docAutomation.json';
import svDocWoocommerce from './locales/sv/docWoocommerce.json';
import svDocShopify from './locales/sv/docShopify.json';
import svCgu from './locales/sv/cgu.json';
import svPrivacy from './locales/sv/privacy.json';
import svFaq from './locales/sv/faq.json';

// Slovak translations (SK - SK)
import skCommon from './locales/sk/common.json';
import skNavigation from './locales/sk/navigation.json';
import skArticles from './locales/sk/articles.json';
import skPricing from './locales/sk/pricing.json';
import skSubscription from './locales/sk/subscription.json';
import skDocumentation from './locales/sk/documentation.json';
import skProfile from './locales/sk/profile.json';
import skAuth from './locales/sk/auth.json';
import skDashboardUser from './locales/sk/dashboardUser.json';
import skSupport from './locales/sk/support.json';
import skHome from './locales/sk/home.json';
import skAffiliate from './locales/sk/affiliate.json';
import skSeo from './locales/sk/seo.json';
import skStatistics from './locales/sk/statistics.json';
import skBilling from './locales/sk/billing.json';
import skTags from './locales/sk/tags.json';
import skMasks from './locales/sk/masks.json';
import skSalesDashboard from './locales/sk/salesDashboard.json';
import skOrders from './locales/sk/orders.json';
import skScheduling from './locales/sk/scheduling.json';
import skActionHistory from './locales/sk/actionHistory.json';
import skDocAutomation from './locales/sk/docAutomation.json';
import skDocWoocommerce from './locales/sk/docWoocommerce.json';
import skDocShopify from './locales/sk/docShopify.json';
import skCgu from './locales/sk/cgu.json';
import skPrivacy from './locales/sk/privacy.json';
import skFaq from './locales/sk/faq.json';

// Helper function to prefix keys recursively
function prefixKeys(obj, prefix) {
  const prefixed = {};
  
  function flattenObject(obj, currentPrefix = '') {
    Object.keys(obj).forEach(key => {
      const fullKey = currentPrefix ? `${currentPrefix}.${key}` : key;
      const prefixedKey = prefix ? `${prefix}.${fullKey}` : fullKey;
      
      if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
        flattenObject(obj[key], fullKey);
      } else {
        prefixed[prefixedKey] = obj[key];
      }
    });
  }
  
  flattenObject(obj);
  return prefixed;
}

const resources = {
  fr: {
    translation: {
      ...frCommon,
      ...frFaq,
      ...frNavigation,
      ...frArticles,
      ...frPricing,
      ...frSubscription,
      ...prefixKeys(frDocumentation, 'documentation'),      
      ...prefixKeys(frProfile, 'profile'),
      ...frAuth,
      ...prefixKeys(frDashboardUser, 'dashboardUser'),
      ...frSupport,
      ...prefixKeys(frHome, 'home'),
      ...prefixKeys(frSeo, 'seo'),
      ...frStatistics,
      ...prefixKeys(frBilling, 'billing'),
      ...prefixKeys(frMasks, 'masks'),
      ...prefixKeys(frSalesDashboard, 'salesDashboard'),
      ...frEmailPreferences,
      ...prefixKeys(frOrders, 'orders'),
      ...prefixKeys(frPaidOptions, 'paidOptions')
    },
    affiliate: frAffiliate,
    tags: frTags,
    scheduling: frScheduling,
    actionHistory: frActionHistory,
    docAutomation: frDocAutomation,
    docWoocommerce: frDocWoocommerce,
    docShopify: frDocShopify,
    cgu: frCgu,
    privacy: frPrivacy
  },
  en: {
    translation: {
      ...enCommon,
      ...enFaq,
      ...enNavigation,
      ...enArticles,
      ...enPricing,
      ...enSubscription,
      ...prefixKeys(enDocumentation, 'documentation'),      
      ...prefixKeys(enProfile, 'profile'),
      ...enAuth,
      ...prefixKeys(enDashboardUser, 'dashboardUser'),
      ...enSupport,
      ...prefixKeys(enHome, 'home'),
      ...prefixKeys(enSeo, 'seo'),
      ...enStatistics,
      ...prefixKeys(enBilling, 'billing'),
      ...prefixKeys(enMasks, 'masks'),
      ...prefixKeys(enSalesDashboard, 'salesDashboard'),
      ...enEmailPreferences,
      ...prefixKeys(enOrders, 'orders'),
      ...prefixKeys(enPaidOptions, 'paidOptions')
    },
    affiliate: enAffiliate,
    tags: enTags,
    scheduling: enScheduling,
    actionHistory: enActionHistory,
    docAutomation: enDocAutomation,
    docWoocommerce: enDocWoocommerce,
    docShopify: enDocShopify,
    cgu: enCgu,
    privacy: enPrivacy
  },
  cs: {
    translation: {
      ...csCommon,
      ...csFaq,
      ...csNavigation,
      ...csArticles,
      ...csPricing,
      ...csSubscription,
      ...prefixKeys(csDocumentation, 'documentation'),      
      ...prefixKeys(csProfile, 'profile'),
      ...csAuth,
      ...prefixKeys(csDashboardUser, 'dashboardUser'),
      ...csSupport,
      ...prefixKeys(csHome, 'home'),
      ...prefixKeys(csSeo, 'seo'),
      ...csStatistics,
      ...prefixKeys(csBilling, 'billing'),
      ...prefixKeys(csMasks, 'masks'),
      ...prefixKeys(csSalesDashboard, 'salesDashboard'),
      ...prefixKeys(csOrders, 'orders')
    },
    affiliate: csAffiliate,
    tags: csTags,
    scheduling: csScheduling,
    actionHistory: csActionHistory,
    docAutomation: csDocAutomation,
    docWoocommerce: csDocWoocommerce,
    docShopify: csDocShopify,
    cgu: csCgu,
    privacy: csPrivacy
  },
  de: {
    translation: {
      ...deCommon,
      ...deFaq,
      ...deNavigation,
      ...deArticles,
      ...dePricing,
      ...deSubscription,
      ...prefixKeys(deDocumentation, 'documentation'),      
      ...prefixKeys(deProfile, 'profile'),
      ...deAuth,
      ...prefixKeys(deDashboardUser, 'dashboardUser'),
      ...deSupport,
      ...prefixKeys(deHome, 'home'),
      ...prefixKeys(deSeo, 'seo'),
      ...deStatistics,
      ...prefixKeys(deBilling, 'billing'),
      ...prefixKeys(deMasks, 'masks'),
      ...prefixKeys(deSalesDashboard, 'salesDashboard'),
      ...prefixKeys(deOrders, 'orders')
    },
    affiliate: deAffiliate,
    tags: deTags,
    scheduling: deScheduling,
    actionHistory: deActionHistory,
    docAutomation: deDocAutomation,
    docWoocommerce: deDocWoocommerce,
    docShopify: deDocShopify,
    cgu: deCgu,
    privacy: dePrivacy
  },
  da: {
    translation: {
      ...daCommon,
      ...daFaq,
      ...daNavigation,
      ...daArticles,
      ...daPricing,
      ...daSubscription,
      ...prefixKeys(daDocumentation, 'documentation'),      
      ...prefixKeys(daProfile, 'profile'),
      ...daAuth,
      ...prefixKeys(daDashboardUser, 'dashboardUser'),
      ...daSupport,
      ...prefixKeys(daHome, 'home'),
      ...prefixKeys(daSeo, 'seo'),
      ...daStatistics,
      ...prefixKeys(daBilling, 'billing'),
      ...prefixKeys(daMasks, 'masks'),
      ...prefixKeys(daSalesDashboard, 'salesDashboard'),
      ...prefixKeys(daOrders, 'orders')
    },
    affiliate: daAffiliate,
    tags: daTags,
    scheduling: daScheduling,
    actionHistory: daActionHistory,
    docAutomation: daDocAutomation,
    docWoocommerce: daDocWoocommerce,
    docShopify: daDocShopify,
    cgu: daCgu,
    privacy: daPrivacy
  },
  es: {
    translation: {
      ...esCommon,
      ...esFaq,
      ...esNavigation,
      ...esArticles,
      ...esPricing,
      ...esSubscription,
      ...prefixKeys(esDocumentation, 'documentation'),      
      ...prefixKeys(esProfile, 'profile'),
      ...esAuth,
      ...prefixKeys(esDashboardUser, 'dashboardUser'),
      ...esSupport,
      ...prefixKeys(esHome, 'home'),
      ...prefixKeys(esSeo, 'seo'),
      ...esStatistics,
      ...prefixKeys(esBilling, 'billing'),
      ...prefixKeys(esMasks, 'masks'),
      ...prefixKeys(esSalesDashboard, 'salesDashboard'),
      ...prefixKeys(esOrders, 'orders')
    },
    affiliate: esAffiliate,
    tags: esTags,
    scheduling: esScheduling,
    actionHistory: esActionHistory,
    docAutomation: esDocAutomation,
    docWoocommerce: esDocWoocommerce,
    docShopify: esDocShopify,
    cgu: esCgu,
    privacy: esPrivacy
  },
  fi: {
    translation: {
      ...fiCommon,
      ...fiFaq,
      ...fiNavigation,
      ...fiArticles,
      ...fiPricing,
      ...fiSubscription,
      ...prefixKeys(fiDocumentation, 'documentation'),      
      ...prefixKeys(fiProfile, 'profile'),
      ...fiAuth,
      ...prefixKeys(fiDashboardUser, 'dashboardUser'),
      ...fiSupport,
      ...prefixKeys(fiHome, 'home'),
      ...prefixKeys(fiSeo, 'seo'),
      ...fiStatistics,
      ...prefixKeys(fiBilling, 'billing'),
      ...prefixKeys(fiMasks, 'masks'),
      ...prefixKeys(fiSalesDashboard, 'salesDashboard'),
      ...prefixKeys(fiOrders, 'orders')
    },
    affiliate: fiAffiliate,
    tags: fiTags,
    scheduling: fiScheduling,
    actionHistory: fiActionHistory,
    docAutomation: fiDocAutomation,
    docWoocommerce: fiDocWoocommerce,
    docShopify: fiDocShopify,
    cgu: fiCgu,
    privacy: fiPrivacy
  },
  el: {
    translation: {
      ...elCommon,
      ...elFaq,
      ...elNavigation,
      ...elArticles,
      ...elPricing,
      ...elSubscription,
      ...prefixKeys(elDocumentation, 'documentation'),      
      ...prefixKeys(elProfile, 'profile'),
      ...elAuth,
      ...prefixKeys(elDashboardUser, 'dashboardUser'),
      ...elSupport,
      ...prefixKeys(elHome, 'home'),
      ...prefixKeys(elSeo, 'seo'),
      ...elStatistics,
      ...prefixKeys(elBilling, 'billing'),
      ...prefixKeys(elMasks, 'masks'),
      ...prefixKeys(elSalesDashboard, 'salesDashboard'),
      ...prefixKeys(elOrders, 'orders')
    },
    affiliate: elAffiliate,
    tags: elTags,
    scheduling: elScheduling,
    actionHistory: elActionHistory,
    docAutomation: elDocAutomation,
    docWoocommerce: elDocWoocommerce,
    docShopify: elDocShopify,
    cgu: elCgu,
    privacy: elPrivacy
  },
  hr: {
    translation: {
      ...hrCommon,
      ...hrFaq,
      ...hrNavigation,
      ...hrArticles,
      ...hrPricing,
      ...hrSubscription,
      ...prefixKeys(hrDocumentation, 'documentation'),      
      ...prefixKeys(hrProfile, 'profile'),
      ...hrAuth,
      ...prefixKeys(hrDashboardUser, 'dashboardUser'),
      ...hrSupport,
      ...prefixKeys(hrHome, 'home'),
      ...prefixKeys(hrSeo, 'seo'),
      ...hrStatistics,
      ...prefixKeys(hrBilling, 'billing'),
      ...prefixKeys(hrMasks, 'masks'),
      ...prefixKeys(hrSalesDashboard, 'salesDashboard'),
      ...prefixKeys(hrOrders, 'orders')
    },
    affiliate: hrAffiliate,
    tags: hrTags,
    scheduling: hrScheduling,
    actionHistory: hrActionHistory,
    docAutomation: hrDocAutomation,
    docWoocommerce: hrDocWoocommerce,
    docShopify: hrDocShopify,
    cgu: hrCgu,
    privacy: hrPrivacy
  },
  hu: {
    translation: {
      ...huCommon,
      ...huFaq,
      ...huNavigation,
      ...huArticles,
      ...huPricing,
      ...huSubscription,
      ...prefixKeys(huDocumentation, 'documentation'),      
      ...prefixKeys(huProfile, 'profile'),
      ...huAuth,
      ...prefixKeys(huDashboardUser, 'dashboardUser'),
      ...huSupport,
      ...prefixKeys(huHome, 'home'),
      ...prefixKeys(huSeo, 'seo'),
      ...huStatistics,
      ...prefixKeys(huBilling, 'billing'),
      ...prefixKeys(huMasks, 'masks'),
      ...prefixKeys(huSalesDashboard, 'salesDashboard'),
      ...prefixKeys(huOrders, 'orders')
    },
    affiliate: huAffiliate,
    tags: huTags,
    scheduling: huScheduling,
    actionHistory: huActionHistory,
    docAutomation: huDocAutomation,
    docWoocommerce: huDocWoocommerce,
    docShopify: huDocShopify,
    cgu: huCgu,
    privacy: huPrivacy
  },
  it: {
    translation: {
      ...itCommon,
      ...itFaq,
      ...itNavigation,
      ...itArticles,
      ...itPricing,
      ...itSubscription,
      ...prefixKeys(itDocumentation, 'documentation'),      
      ...prefixKeys(itProfile, 'profile'),
      ...itAuth,
      ...prefixKeys(itDashboardUser, 'dashboardUser'),
      ...itSupport,
      ...prefixKeys(itHome, 'home'),
      ...prefixKeys(itSeo, 'seo'),
      ...itStatistics,
      ...prefixKeys(itBilling, 'billing'),
      ...prefixKeys(itMasks, 'masks'),
      ...prefixKeys(itSalesDashboard, 'salesDashboard'),
      ...prefixKeys(itOrders, 'orders')
    },
    affiliate: itAffiliate,
    tags: itTags,
    scheduling: itScheduling,
    actionHistory: itActionHistory,
    docAutomation: itDocAutomation,
    docWoocommerce: itDocWoocommerce,
    docShopify: itDocShopify,
    cgu: itCgu,
    privacy: itPrivacy
  },
  lt: {
    translation: {
      ...ltCommon,
      ...ltFaq,
      ...ltNavigation,
      ...ltArticles,
      ...ltPricing,
      ...ltSubscription,
      ...prefixKeys(ltDocumentation, 'documentation'),      
      ...prefixKeys(ltProfile, 'profile'),
      ...ltAuth,
      ...prefixKeys(ltDashboardUser, 'dashboardUser'),
      ...ltSupport,
      ...prefixKeys(ltHome, 'home'),
      ...prefixKeys(ltSeo, 'seo'),
      ...ltStatistics,
      ...prefixKeys(ltBilling, 'billing'),
      ...prefixKeys(ltMasks, 'masks'),
      ...prefixKeys(ltSalesDashboard, 'salesDashboard'),
      ...prefixKeys(ltOrders, 'orders')
    },
    affiliate: ltAffiliate,
    tags: ltTags,
    scheduling: ltScheduling,
    actionHistory: ltActionHistory,
    docAutomation: ltDocAutomation,
    docWoocommerce: ltDocWoocommerce,
    docShopify: ltDocShopify,
    cgu: ltCgu,
    privacy: ltPrivacy
  },
  nl: {
    translation: {
      ...nlCommon,
      ...nlFaq,
      ...nlNavigation,
      ...nlArticles,
      ...nlPricing,
      ...nlSubscription,
      ...prefixKeys(nlDocumentation, 'documentation'),      
      ...prefixKeys(nlProfile, 'profile'),
      ...nlAuth,
      ...prefixKeys(nlDashboardUser, 'dashboardUser'),
      ...nlSupport,
      ...prefixKeys(nlHome, 'home'),
      ...prefixKeys(nlSeo, 'seo'),
      ...nlStatistics,
      ...prefixKeys(nlBilling, 'billing'),
      ...prefixKeys(nlMasks, 'masks'),
      ...prefixKeys(nlSalesDashboard, 'salesDashboard'),
      ...prefixKeys(nlOrders, 'orders')
    },
    affiliate: nlAffiliate,
    tags: nlTags,
    scheduling: nlScheduling,
    actionHistory: nlActionHistory,
    docAutomation: nlDocAutomation,
    docWoocommerce: nlDocWoocommerce,
    docShopify: nlDocShopify,
    cgu: nlCgu,
    privacy: nlPrivacy
  },
  pl: {
    translation: {
      ...plCommon,
      ...plFaq,
      ...plNavigation,
      ...plArticles,
      ...plPricing,
      ...plSubscription,
      ...prefixKeys(plDocumentation, 'documentation'),      
      ...prefixKeys(plProfile, 'profile'),
      ...plAuth,
      ...prefixKeys(plDashboardUser, 'dashboardUser'),
      ...plSupport,
      ...prefixKeys(plHome, 'home'),
      ...prefixKeys(plSeo, 'seo'),
      ...plStatistics,
      ...prefixKeys(plBilling, 'billing'),
      ...prefixKeys(plMasks, 'masks'),
      ...prefixKeys(plSalesDashboard, 'salesDashboard'),
      ...prefixKeys(plOrders, 'orders')
    },
    affiliate: plAffiliate,
    tags: plTags,
    scheduling: plScheduling,
    actionHistory: plActionHistory,
    docAutomation: plDocAutomation,
    docWoocommerce: plDocWoocommerce,
    docShopify: plDocShopify,
    cgu: plCgu,
    privacy: plPrivacy
  },
  pt: {
    translation: {
      ...ptCommon,
      ...ptFaq,
      ...ptNavigation,
      ...ptArticles,
      ...ptPricing,
      ...ptSubscription,
      ...prefixKeys(ptDocumentation, 'documentation'),      
      ...prefixKeys(ptProfile, 'profile'),
      ...ptAuth,
      ...prefixKeys(ptDashboardUser, 'dashboardUser'),
      ...ptSupport,
      ...prefixKeys(ptHome, 'home'),
      ...prefixKeys(ptSeo, 'seo'),
      ...ptStatistics,
      ...prefixKeys(ptBilling, 'billing'),
      ...prefixKeys(ptMasks, 'masks'),
      ...prefixKeys(ptSalesDashboard, 'salesDashboard'),
      ...prefixKeys(ptOrders, 'orders')
    },
    affiliate: ptAffiliate,
    tags: ptTags,
    scheduling: ptScheduling,
    actionHistory: ptActionHistory,
    docAutomation: ptDocAutomation,
    docWoocommerce: ptDocWoocommerce,
    docShopify: ptDocShopify,
    cgu: ptCgu,
    privacy: ptPrivacy
  },
  ro: {
    translation: {
      ...roCommon,
      ...roFaq,
      ...roNavigation,
      ...roArticles,
      ...roPricing,
      ...roSubscription,
      ...prefixKeys(roDocumentation, 'documentation'),      
      ...prefixKeys(roProfile, 'profile'),
      ...roAuth,
      ...prefixKeys(roDashboardUser, 'dashboardUser'),
      ...roSupport,
      ...prefixKeys(roHome, 'home'),
      ...prefixKeys(roSeo, 'seo'),
      ...roStatistics,
      ...prefixKeys(roBilling, 'billing'),
      ...prefixKeys(roMasks, 'masks'),
      ...prefixKeys(roSalesDashboard, 'salesDashboard'),
      ...prefixKeys(roOrders, 'orders')
    },
    affiliate: roAffiliate,
    tags: roTags,
    scheduling: roScheduling,
    actionHistory: roActionHistory,
    docAutomation: roDocAutomation,
    docWoocommerce: roDocWoocommerce,
    docShopify: roDocShopify,
    cgu: roCgu,
    privacy: roPrivacy
  },
  sv: {
    translation: {
      ...svCommon,
      ...svFaq,
      ...svNavigation,
      ...svArticles,
      ...svPricing,
      ...svSubscription,
      ...prefixKeys(svDocumentation, 'documentation'),      
      ...prefixKeys(svProfile, 'profile'),
      ...svAuth,
      ...prefixKeys(svDashboardUser, 'dashboardUser'),
      ...svSupport,
      ...prefixKeys(svHome, 'home'),
      ...prefixKeys(svSeo, 'seo'),
      ...svStatistics,
      ...prefixKeys(svBilling, 'billing'),
      ...prefixKeys(svMasks, 'masks'),
      ...prefixKeys(svSalesDashboard, 'salesDashboard'),
      ...prefixKeys(svOrders, 'orders')
    },
    affiliate: svAffiliate,
    tags: svTags,
    scheduling: svScheduling,
    actionHistory: svActionHistory,
    docAutomation: svDocAutomation,
    docWoocommerce: svDocWoocommerce,
    docShopify: svDocShopify,
    cgu: svCgu,
    privacy: svPrivacy
  },
  sk: {
    translation: {
      ...skCommon,
      ...skFaq,
      ...skNavigation,
      ...skArticles,
      ...skPricing,
      ...skSubscription,
      ...prefixKeys(skDocumentation, 'documentation'),      
      ...prefixKeys(skProfile, 'profile'),
      ...skAuth,
      ...prefixKeys(skDashboardUser, 'dashboardUser'),
      ...skSupport,
      ...prefixKeys(skHome, 'home'),
      ...prefixKeys(skSeo, 'seo'),
      ...skStatistics,
      ...prefixKeys(skBilling, 'billing'),
      ...prefixKeys(skMasks, 'masks'),
      ...prefixKeys(skSalesDashboard, 'salesDashboard'),
      ...prefixKeys(skOrders, 'orders')
    },
    affiliate: skAffiliate,
    tags: skTags,
    scheduling: skScheduling,
    actionHistory: skActionHistory,
    docAutomation: skDocAutomation,
    docWoocommerce: skDocWoocommerce,
    docShopify: skDocShopify,
    cgu: skCgu,
    privacy: skPrivacy
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false
    },
    debug: false,
    detection: {
      order: ['localStorage', 'cookie', 'htmlTag', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      lookupCookie: 'i18nextLng',
      caches: ['localStorage', 'cookie']
    },
    saveMissing: false,
    missingKeyHandler: (lng, ns, key, fallbackValue) => {
      if (process.env.NODE_ENV === 'development') {
        console.warn(`i18next: Missing translation key "${key}" for language "${lng}"`);
      }
    }
  });

export default i18n;
